<div class="noPrint w-full max-w-3xl mx-auto px-4 py-5 flex flex-col sm:flex-row gap-3 items-stretch">
  <button
    type="button"
    (click)="onPrint()"
    [disabled]="pdfBusy"
    class="inline-flex items-center justify-center gap-2 min-h-[48px] px-5 py-2.5 rounded-lg text-base font-semibold text-white bg-primary-500 hover:bg-primary-600 disabled:opacity-60 transition-colors flex-1"
  >
    <span class="material-symbols-outlined" aria-hidden="true">print</span>
    <span>הדפס</span>
  </button>

  <button
    type="button"
    (click)="downloadPdf()"
    [disabled]="pdfBusy"
    class="inline-flex items-center justify-center gap-2 min-h-[48px] px-5 py-2.5 rounded-lg text-base font-semibold text-white bg-accent-500 hover:bg-accent-600 disabled:opacity-60 transition-colors flex-1"
    aria-label="הורד את טבלת היתרות כקובץ PDF"
  >
    <span *ngIf="!pdfBusy" class="material-symbols-outlined" aria-hidden="true">download</span>
    <span *ngIf="pdfBusy" class="material-symbols-outlined animate-spin" aria-hidden="true">progress_activity</span>
    <span>{{ pdfBusy ? 'מכין PDF...' : 'הורד PDF' }}</span>
  </button>

  <!-- WhatsApp share — only visible when the browser truly supports
       sharing a PDF File via the Web Share API (mobile Safari/Chrome).
       Desktop browsers hide the button entirely. -->
  <button
    *ngIf="canShareFiles"
    type="button"
    (click)="shareViaWhatsApp()"
    [disabled]="pdfBusy"
    class="inline-flex items-center justify-center gap-2 min-h-[48px] px-5 py-2.5 rounded-lg text-base font-semibold text-white bg-[#25D366] hover:bg-[#1ebe5d] disabled:opacity-60 transition-colors flex-1"
    aria-label="שלח את טבלת היתרות בוואטסאפ"
  >
    <span *ngIf="!pdfBusy" class="material-symbols-outlined" aria-hidden="true">send</span>
    <span *ngIf="pdfBusy" class="material-symbols-outlined animate-spin" aria-hidden="true">progress_activity</span>
    <span>{{ pdfBusy ? 'מכין PDF...' : 'שלח בוואטסאפ' }}</span>
  </button>
</div>

<div class="tableWrap w-full grid grid-cols-3" dir="rtl">
  <ng-container *ngIf="usersList$ | async">

    <!-- Right column (first half) -->
    <div class="overflow-x-auto">
      <table class="balanceTable border-l-2">
        <thead>
          <tr>
            <th>שם</th>
            <th class="balanceCol">יתרה</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of usersPart1">
            <td class="nameCol">{{ user.firstName }} {{ user.lastName }}</td>
            <td class="balanceCol"
                [class.credit]="user.balance > 0"
                [class.debt]="user.balance < 0">{{ user.balance > 0 ? '+' : '' }}{{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Middle column (synagogue identity / verse / bank) -->
    <div class="centerPanel flex flex-col items-center justify-between text-black">
      <div class="w-full flex flex-col items-center">
        <app-logo [print]="true"></app-logo>
        <h2 class="stamFont text-accent-600 text-2xl font-extrabold text-center pt-4 leading-tight px-2">
          כִּי תִדֹּר נֶדֶר לַיהוָה אֱלֹהֶיךָ לֹא תְאַחֵר לְשַׁלְּמוֹ
        </h2>
      </div>

      <div *ngIf="shabbatData" class="w-full flex flex-col gap-0.5 justify-center items-center text-center font-semibold">
        <p class="stamFont text-3xl text-nowrap">{{ shabbatData.parasha }}</p>
        <p class="text-ink-500 text-sm">{{ shabbatData.hebrew }}</p>
      </div>

      <div class="text-center text-xs leading-tight">
        <p>בנק דיסקונט חשבון 9494, סניף 187</p>
        <p>בית כנסת תפארת ישראל</p>
      </div>

      <div class="text-center text-success text-sm">
        <h3 class="font-bold">בברכת שבת שלום</h3>
        <h4>ועד בית הכנסת</h4>
      </div>
    </div>

    <!-- Left column (second half) -->
    <div class="overflow-x-auto">
      <table class="balanceTable border-r-2">
        <thead>
          <tr>
            <th>שם</th>
            <th class="balanceCol">יתרה</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of usersPart2">
            <td class="nameCol">{{ user.firstName }} {{ user.lastName }}</td>
            <td class="balanceCol"
                [class.credit]="user.balance > 0"
                [class.debt]="user.balance < 0">{{ user.balance > 0 ? '+' : '' }}{{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-container>
</div>
